import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { PageService } from 'app/services/models/page.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-page',
  templateUrl: './create-page.component.html',
  styleUrls: ['./create-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreatePageComponent implements OnInit {
  pageForm: FormGroup;
  @Input() page: any;
  isEditMode = false;

  constructor(
    private formBuilder: FormBuilder,
    private _coreSidebarService: CoreSidebarService,
    private toastrService: ToastrService,
    private pageService: PageService) { }

  async ngOnInit() {
    console.log(this.page)
    this.initializeForm();
    await this.getAllPageList();
  }

  getAllPage: any = [];

  async getAllPageList() {

    const data = await this.pageService.getAllPagesList(0, 100);
    this.getAllPage = data.pages;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['page'] && this.page) {
      if (this.pageForm) {
        this.pageForm.reset();
      }
      this.isEditMode = true;

      this.pageForm.patchValue({
        title: this.page.title || '',
        url: this.page.url || '',
        icon: this.page.icon || '',
        type: this.page.type || '',
        parentId: this.page?.parentId ?? null,
        order : this.page.order
      });

    }

  }

  initializeForm() {
    this.pageForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(25)]],
      url: [null],
      icon: ['', [Validators.required]],
      type: ['', [Validators.required]],
      parentId: [null],
      order:[null,[Validators.required]]
    });
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async onSubmit() {
    if (this.pageForm.valid) {
      const title = this.pageForm.get('title').value;
      const url = this.pageForm.get('url').value;
      const icon = this.pageForm.get('icon').value;
      const type = this.pageForm.get('type').value;
      const parentId = this.pageForm.get('parentId').value == 0 ? null : this.pageForm.get('parentId').value;
      const order = this.pageForm.get('order').value;
      console.log(this.isEditMode)
      console.log(order);
      console.log(parentId)
      let data;

      if (this.isEditMode && this.page && this.page.id) {
        data = await this.pageService.updatePage(this.page.id, title, url, icon, type, parentId,order);
      } else {
        data = await this.pageService.createPage(title, url, icon, type, parentId,order);
      }

      if(data.status == true){
        this.pageService.sendEvent(true);
        this.toastrService.success(data.message);
      }else{
        this.toastrService.error(data.message);
      }
      this.toggleSidebar('create-page');
    }
  }

}
